import { Fragment, PropsWithChildren } from 'react';

import { compatWrapper } from '@backstage/core-compat-api';
import { AppRootWrapperBlueprint } from '@backstage/frontend-plugin-api';

import { ConfidenceProvider } from '@spotify-confidence/react';
import {
  ConfidenceCoreProvider,
  ResourceLinkExtensions,
  useAuth,
} from '@spotify/confidence-core-react';
import { AppAccountRedirect } from '@spotify/plugin-confidence-app-react';
import { IdentityResourceLinkExtension } from '@spotify/plugin-confidence-iam';
import { WorkflowInstanceResourceLinkExtension } from '@spotify/plugin-confidence-workflows';

import { confidenceApi } from '../apis/Apis';
import { FlagContext } from './FlagContext';
import { Header } from './Header';

const resourceLinkExtensions = (
  <ResourceLinkExtensions>
    <IdentityResourceLinkExtension />
    <WorkflowInstanceResourceLinkExtension />
  </ResourceLinkExtensions>
);

const Root = ({ children }: PropsWithChildren<{}>) => {
  const { isAuthenticated } = useAuth();

  return (
    <Fragment>
      {resourceLinkExtensions}

      {isAuthenticated && (
        <Fragment>
          <Header />
          <AppAccountRedirect />
        </Fragment>
      )}

      {children}
    </Fragment>
  );
};

export const RootWrapper = AppRootWrapperBlueprint.make({
  name: 'AppRootWrapper',
  params: {
    component: ({ children }) => {
      return compatWrapper(
        <ConfidenceProvider confidence={confidenceApi}>
          <ConfidenceCoreProvider>
            <FlagContext>
              <Root>{children}</Root>
            </FlagContext>
          </ConfidenceCoreProvider>
        </ConfidenceProvider>,
      );
    },
  },
});
